import React, { useEffect, useState } from "react";
import GenericCrudPage from "../common/GenericCrudPage";
import { getClasses, createClass, updateClass, deleteClass } from "../../../services/ClassService";
import { getDepartments } from "../../../services/DepartmentService";
import { getLevels } from "../../../services/LevelService";
import { getAcademicYears } from "../../../services/AcademicYearService";
import { useTranslation } from "react-i18next";

const Classes = () => {
  const { t } = useTranslation();
  const [departments, setDepartments] = useState([]);
  const [levels, setLevels] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);

  useEffect(() => {
    getDepartments({ page: 1, limit: 200 }).then((res) => setDepartments(res.data?.data || [])).catch(() => {});
    getLevels({ page: 1, limit: 200 }).then((res) => setLevels(res.data?.data || [])).catch(() => {});
    getAcademicYears({ page: 1, limit: 200 }).then((res) => setAcademicYears(res.data?.data || [])).catch(() => {});
  }, []);

  const label = (list, id) => list.find((x) => x.id === id)?.name || "-";

  return (
    <GenericCrudPage
      permissionModule="CLASS"
      title={t("pages.classes.title")}
      breadcrumbLabel={t("menu.classes.title")}
      addLabel={t("pages.classes.addLabel")}
      searchPlaceholder={t("common.ui.rechercherCodeNom")}
      defaultSort={{ by: "name", dir: "asc" }}
      api={{ list: getClasses, create: createClass, update: updateClass, remove: deleteClass }}
      filters={[
        { key: "department_id", label: t("common.fields.allDepartments"), options: departments.map((d) => ({ value: d.id, label: d.name })) },
        { key: "academic_year_id", label: t("common.fields.allYears"), options: academicYears.map((y) => ({ value: y.id, label: y.name })) },
      ]}
      columns={[
        { key: "code", label: t("common.fields.code"), sortable: true },
        { key: "name", label: t("common.fields.name"), sortable: true },
        { key: "department_id", label: t("common.fields.department"), render: (row) => label(departments, row.department_id) },
        { key: "level_id", label: t("common.fields.level"), render: (row) => label(levels, row.level_id) },
        { key: "academic_year_id", label: t("common.fields.year"), render: (row) => label(academicYears, row.academic_year_id) },
        { key: "capacity", label: t("common.fields.capacity"), render: (row) => row.capacity ?? "-" },
      ]}
      fields={[
        { key: "department_id", label: t("common.fields.department"), type: "select", required: true, options: departments.map((d) => ({ value: d.id, label: d.name })) },
        { key: "level_id", label: t("common.fields.level"), type: "select", required: true, options: levels.map((l) => ({ value: l.id, label: l.name })) },
        { key: "academic_year_id", label: t("common.fields.academicYear"), type: "select", required: true, options: academicYears.map((y) => ({ value: y.id, label: y.name })) },
        { key: "code", label: t("common.fields.code"), type: "text", required: true, placeholder: "INFO-L1-A", maxLength: 30 },
        { key: "name", label: t("common.fields.name"), type: "text", required: true, placeholder: t("pages.classes.informatiqueLicence1Groupe"), maxLength: 150 },
        { key: "capacity", label: t("common.fields.capacity"), type: "number", placeholder: "40" },
        { key: "description", label: t("common.fields.description"), type: "textarea" },
        { key: "is_active", label: t("common.crud.statusActive"), type: "checkbox" },
      ]}
      buildPayload={(formData) => ({
        department_id: formData.department_id,
        level_id: formData.level_id,
        academic_year_id: formData.academic_year_id,
        code: formData.code.trim(),
        name: formData.name.trim(),
        capacity: formData.capacity !== "" ? Number(formData.capacity) : null,
        description: formData.description?.trim() || null,
        is_active: formData.is_active !== undefined ? !!formData.is_active : true,
      })}
      getItemLabel={(item) => item.name}
    />
  );
};

export default Classes;
